import Tastet from '../tastet.js';

const CLASSES = {
  SHOW_MOBILE: 'header--mobile-view',
  SHOW_SEARCH: 'quick-search--visible',
  IS_OPEN: 'open',
  NO_OVERFLOW: 'freeze',
};

export default class Header extends Tastet.View {
  // init ------------------------------------------------------------------------------------------------------------
  init() {}

  addEvents() {
    this.$mobile_btn && this.on(this.$mobile_btn, 'click', this.showMobile_onClick);
    this.on(this.$body, 'click', { delegate: '[data-action="show_search"]', callback: this.showSearch_onClick });

    // Close the slide-down search when clicking outside of it (otherwise there's no way to dismiss it).
    document.addEventListener('click', this.hideSearchOnOutsideClick.bind(this));
  }

  render() {}

  hideSearchOnOutsideClick(e) {
    var quicky = document.querySelector('.quick-search');
    if (!quicky || !quicky.classList.contains(CLASSES.SHOW_SEARCH)) return;

    // Keep it open when clicking the trigger or anywhere inside the search panel.
    if (e.target.closest('[data-action="show_search"]') || e.target.closest('.quick-search')) return;

    quicky.classList.remove(CLASSES.SHOW_SEARCH);
  }

  // private ---------------------------------------------------------------------------------------------------------

  // events ----------------------------------------------------------------------------------------------------------
  showMobile_onClick() {
    this.$element.toggleClass(CLASSES.SHOW_MOBILE);
    this.$mobile_btn.toggleClass(CLASSES.IS_OPEN);
    this.$body.toggleClass(CLASSES.NO_OVERFLOW);
  }

  showSearch_onClick() {
    this.$quicky.toggleClass(CLASSES.SHOW_SEARCH);

    // Give focus to search on visible
    if (this.$quicky.hasClass(CLASSES.SHOW_SEARCH)) {
      var searchInput = document.querySelector('div.quick-search input[type="search"]');

      // preventScroll: the panel is already visible (sticky header), so don't let focus jump the page to top.
      searchInput && searchInput.focus({ preventScroll: true });
    }
  }
}
